import { forwardRef, Fragment } from 'react';
import cx from 'classnames';
import { setAlpha } from '../../design-tokens';
import { renderInlineCssVars, useDesignTokens } from '../../theme';
import { ButtonVariant } from '../Button';
import { BaseButton } from '../Button/__internal__';
import { Icon } from '../Icon';
import { useIconA11yInfo } from '../Icon/useIconA11yInfo';
import buttonCn from '../Button/__internal__/BaseButton.css.json';
import cn from './BadgeButton.css.json';
import './BadgeButton.css';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const BadgeButton = /*#__PURE__*/forwardRef(function BadgeButton({
  badgeDesign = 'basic',
  children,
  icon,
  value,
  showZeroValue,
  variant,
  tooltip: customTooltip,
  ariaLabel: customAriaLabel,
  ...props
}, ref) {
  const badgeValue = value > 999 ? '999+' : value;
  const valueValid = value > 0 || value === 0 && !!showZeroValue;
  const dt = useDesignTokens();
  let squareBadgeStyle;
  if (badgeDesign === 'square') {
    squareBadgeStyle = renderInlineCssVars({
      bg: props.disabled ? setAlpha(dt.tokens['color-secondary'], 0.32) : dt.tokens['color-secondary'],
      fg: dt.themeVariant === 'dark' ? dt.tokens['color-text-neutral'] : dt.tokens['color-text-neutral-inverse'],
      'border-radius': dt.tokens['size-border-radius-xxs']
    }, 'badge-button');
  }
  const token = {
    ...renderInlineCssVars({
      padding: `${dt.tokens['space-base-xs']} ${dt.tokens['space-base-s']}`
    }, 'badge-button'),
    ...renderInlineCssVars({
      'spacing-xs': dt.tokens['space-base-xs'],
      'font-size-m': dt.tokens['font-size-body-text-m'],
      'font-weight-thick': dt.tokens['font-style-weight-700']
    }, 'badge-button-text')
  };
  const badgeSpan = /*#__PURE__*/_jsx("span", {
    className: cn.text,
    dir: "ltr",
    children: badgeValue
  });
  const badgeIcon = icon ? /*#__PURE__*/_jsx(Icon, {
    ...icon,
    className: cx(buttonCn.iconInner, icon.className),
    tooltip: "",
    ariaLabel: ""
  }) : undefined;
  let badgeContent;
  if (badgeDesign === 'square') {
    if (valueValid) {
      badgeContent = badgeSpan;
    } else {
      badgeContent = badgeIcon;
    }
  } else {
    badgeContent = /*#__PURE__*/_jsxs(Fragment, {
      children: [badgeIcon, badgeSpan]
    });
  }
  const getIconA11yInfo = useIconA11yInfo();
  const {
    tooltip: iconTooltip = undefined
  } = icon ? getIconA11yInfo(icon) : {};
  const tooltip = customTooltip ?? (badgeDesign === 'basic' || !valueValid ? iconTooltip : undefined);
  const needValue = customTooltip === undefined && badgeDesign === 'basic' && valueValid && icon;
  const ariaLabel = customAriaLabel ?? (tooltip === undefined ? undefined : needValue ? `${tooltip} (${badgeValue})` : tooltip);
  return /*#__PURE__*/_jsx(BaseButton, {
    variant: variant ? variant : ButtonVariant.Icon,
    ...props,
    className: cx(cn.baseButton, props.className),
    tooltip: tooltip,
    ariaLabel: ariaLabel,
    ref: ref,
    style: {
      ...squareBadgeStyle,
      ...token
    },
    children: /*#__PURE__*/_jsx("div", {
      className: cx(cn.basic, valueValid && badgeDesign === 'square' && cn.square, badgeSpan && icon && badgeDesign === 'basic' && cn.withTextIcon),
      children: badgeContent
    })
  });
});
//# sourceMappingURL=BadgeButton.js.map